import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslationBundle } from '../../../models/translation-bundle.model';

@Component({
  selector: 'app-topic-checklist',
  templateUrl: './topic-checklist.component.html',
  styleUrls: ['./topic-checklist.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopicChecklistComponent {

  @Input() topics: string[] = [];
  @Input() topicTranslations: (TranslationBundle | null)[] = [];
  @Input() checklist: { [topicIndex: string]: boolean } = {};
  @Input() isDisabled: boolean = false;
  @Input() isChatActionDisabled: boolean = false;

  @Output() topicToggled = new EventEmitter<number>();
  @Output() topicChatRequested = new EventEmitter<string>();

  trackByTopicIndex(index: number): number {
    return index;
  }

  isTopicChecked(index: number): boolean {
    return this.checklist && this.checklist[String(index)] === true;
  }

  onTopicClick(index: number): void {
    if (!this.isDisabled) {
      this.topicToggled.emit(index);
    }
  }

  onTopicChatClick(topic: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDisabled || this.isChatActionDisabled) {
      return;
    }
    this.topicChatRequested.emit(topic);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/topic-checklist/topic-checklist.component.ts